// AXIOS
import axios from "axios";

// api url
import { apiToken, apiUrl_forSettings, apiUrl_forCart } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get admin users
export let cancelGetShippingMethodsApi;
export async function getShippingMethodsApi(token, { cart_weight, cart_total }) {
    if (cart_weight && cart_total) {
        const users = await axios.post(
            apiUrl_forSettings + `shipping/cart`,
            {
                cart_weight,
                cart_total
            },
            {
                headers: {
                    "Authorization": `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetShippingMethodsApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}

// get admin users
export let cancelGetCartDetailsAfterPaymentMethodApi;
export async function getCartDetailsAfterPaymentMethodApi(token, { temp_order_id, shippingsetting_id }) {
    if (temp_order_id) {
        const users = await axios.post(
            apiUrl_forCart + `update/shipping`,
            { temp_order_id, shippingsetting_id },
            {
                headers: {
                    "Authorization": `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCartDetailsAfterPaymentMethodApi = c;
                }),
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}